<form
  class="flex w-full flex-col gap-4"
  [class.px-8]="padded()"
  [class.py-8]="padded()"
  [class.sm:py-9]="padded()"
  #transferForm="ngForm"
  (ngSubmit)="transferBudget(direction, transferForm)"
  autocomplete="off"
>
  <header class="flex flex-col gap-1">
    <h3 class="text-base font-bold text-text-title">Move funds</h3>
    <p class="text-sm text-text-secondary">Shift budgeted dollars between this budget and another.</p>
    @if (pastMonthLabel(); as label) {
      <p class="text-sm font-semibold text-text-title" data-testid="transfer-budget-past-month">
        Recorded in {{ label }}.
      </p>
    }
  </header>

  @if (directionOptions().length > 1) {
    <app-ui-radio-group
      legend="Transfer"
      name="direction"
      [(ngModel)]="direction"
      [ngModelOptions]="{ standalone: true }"
      [options]="directionOptions()"
      required
    />
  }

  <app-select-bucket-typeahead
    [label]="direction === 'in' ? 'From budget' : 'To budget'"
    [buckets]="availableBuckets()"
    [(selectedBucket)]="selectedBucket"
    [options]="{ showFundBalance: true }"
    [required]="true"
  />

  <app-ui-field label="Transfer Amount" [inputId]="'transfer-amount'">
    <app-ui-currency-input
      inputId="transfer-amount"
      name="amount"
      [min]="minTransfer"
      [max]="maxTransfer"
      placeholder="0.00"
      required
      [(ngModel)]="transfer.amount"
    />
  </app-ui-field>
  @if (options().allowNegativeAmount) {
    <p class="-mt-1 text-xs text-text-secondary">Enter a negative amount to move funds back to Available Balance.</p>
  }

  <button appUiButton appearance="solid" tone="primary" type="submit" class="mt-2 self-stretch" [disabled]="loading">
    {{ direction === 'in' ? 'Transfer In' : 'Transfer Out' }}
  </button>
</form>
